import { TitleProps } from 'antd/es/typography/Title';
import styled from 'styled-components';

import { FormItemLabelType, FormLabelItem } from '@/shared/lib/forms/form-wrapper.types';
import { Title } from '@/shared/uikit/Title';

export const REQUIRED_ERROR = 'Field is required';
export const INVALID_EMAIL_ERROR = 'Email is invalid';
export const EMAIL_REGEX = /^\S+@\S+\.\S+$/;

type Item = {
  id: string;
  name?: string;
  nickname?: string;
  nickName?: string;
  shortname?: string;
  isTest?: boolean;
};

const TITLE_LEVELS: Record<string, TitleProps['level']> = {
  [FormLabelItem.h1]: 1,
  [FormLabelItem.label]: 5,
};

export const getRequiredRule = (question: { required?: boolean }) =>
  question.required ? REQUIRED_ERROR : false;

export const renderText = (
  data: FormItemLabelType<unknown>,
  key: string,
  t: (key: string) => string,
) => {
  return (
    <Container key={key}>
      {data.type === FormLabelItem.text ? (
        <span>{t(data.label)}</span>
      ) : (
        <Title bold level={TITLE_LEVELS[data.type]}>
          {t(data.label)}
        </Title>
      )}
    </Container>
  );
};

export const commonFilterCollection = (item: Item) => {
  return (
    Boolean(item.name || item.nickName || item.nickname || item.shortname) && !item.isTest // TODO its test assets for test scenarios
  );
};

const Container = styled.div`
  grid-column: 1 / -1;
`;

export const capitalizeValue = (value: string): string => {
  if (!value || typeof value !== 'string') return value;
  return value.toUpperCase();
};
